import React, {Fragment} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, MultipleSelect, Explanation_text} from '../../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {connect} from 'react-redux';

function External_crm_setup_popup(props){

  function onSubmit(params){props.updateExternalCrmSetup(params);}

  let crm_name=capitalizeFirstLetter(props.crm_login.crm_type.toLowerCase());
  const delete_policy_options=[{id:0, name:'Isolate deletes'}, {id:1, name:'Delete only on ProspectSafari'}, {id:2, name:'Delete only on '+crm_name}, {id:3, name:'Delete both ways'}];

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={{crm_login_id:props.crm_login.id, companies:props.crm_login.companies, contacts:props.crm_login.contacts, timeline_items:props.crm_login.timeline_items, trigger_connection_statuses:JSON.parse(props.crm_login.trigger_connection_statuses), trigger_disconnection_statuses:JSON.parse(props.crm_login.trigger_disconnection_statuses), delete_policy:props.crm_login.delete_policy}}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit();  props.handleClose();}}  always_open title={window.capitalizeFirstLetter(crm_name)+' setup'} content={
          <div style={{width:'95vw', maxWidth:'600px', marginTop:'20px'}}>
              <div style={{width:'calc(100% - 60px)', marginLeft:'30px'}}><Field name='companies'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange} name="companies" color="primary"/>}label={<Explanation_text inline text="Companies"/>}/>}</Field></div>
              <div style={{width:'calc(100% - 60px)', marginLeft:'30px'}}><Field name='contacts'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange} name="contacts" color="primary"/>}label={<Explanation_text inline text="Contacts"/>}/>}</Field></div>
              <div style={{width:'calc(100% - 60px)', marginLeft:'30px'}}><Field name='timeline_items'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange} name="timeline_items" color="primary"/>}label={<Explanation_text inline text="Timeline items"/>}/>}</Field></div>
              <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'10px'}}><Select title='Delete policy' name='delete_policy' select_data={delete_policy_options}/></div>
              <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>
                  <Grid item xs={12} sm={6} style={{marginTop:'10px', marginBottom:'20px'}}><Field name='trigger_connection_statuses'>{(f)=><MultipleSelect title='Connect on status' with_id={true} possible_json required name='trigger_connection_statuses' value={f.input.value} onChange={f.input.onChange} enum='status'/>}</Field></Grid>
                  <Grid item xs={12} sm={6} style={{marginTop:'10px', marginBottom:'20px'}}><Field name='trigger_disconnection_statuses'>{(f)=><MultipleSelect title='Disconnect on status' with_id={true} possible_json required name='trigger_disconnection_statuses' value={f.input.value} onChange={f.input.onChange} enum='status'/>}</Field></Grid>
              </Grid>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}


export default connect(ss, dd)(External_crm_setup_popup);

function ss(state){
  return{
    enumerations:state.account.enumerations
  }
}

function dd(dispatch){
  return{
    updateExternalCrmSetup:(params)=>{dispatch({type:'REQUEST_UPDATE_EXTERNAL_CRM_SETUP', payload:params})}
  }
}
